import {
  fetchAll,
  fetchFiltered,
  fetchFilteredForGarage,
  fetchFilteredForOs,
  getAllAvailableToChange,
  exchangeActive,
  addActiveInOs,
  removeActiveInOs,
  create,
  movementBatch,
  activesMovementReport,
  show,
  edit,
  fetchAllSimcard,
  linkTrackerAndSimcard,
  loadActivesByService,
  fetchActivesMovementReportPDF,
  linkActiveModelAndSimcard,
  addTrackersBatch,
  addSimcardsBatch
} from '@/api/active'

const state = {
  all: [],
  allAvailableToChange: [],
  isLoading: false,
  activeById: null,
  activesMovementReport: [],
  allSimcard: [],
  addTrackersBatchErrors: [],
  addSimcardsBatchErrors: []
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const active = await show(id)
      commit('setActiveById', active)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const actives = await fetchAll()
      commit('setAll', actives)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const actives = await fetchFiltered(queriesParams)
      commit('setAll', actives)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFilteredForGarage ({ dispatch, commit }, queriesParams) {
    try {
      const actives = await fetchFilteredForGarage(queriesParams)
      commit('setAll', actives)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFilteredForOs ({ dispatch, commit }, queriesParams) {
    try {
      const actives = await fetchFilteredForOs(queriesParams)
        commit('setAll', actives)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async getAllAvailableToChange ({ dispatch, commit }, queriesParams) {
    try {
      const actives = await getAllAvailableToChange(queriesParams)
        commit('setAllAvailable', actives)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async exchangeActive ({ dispatch, commit }, data) {
    try {
      await exchangeActive(data)
      return true
    } catch (e) {
      return false
    }
  },

  async addActiveInOs ({ dispatch, commit }, data) {
    try {
      await addActiveInOs(data)
      return true
    } catch (e) {
      return false
    }
  },

  async removeActiveInOs ({ dispatch, commit }, data) {
    try {
      await removeActiveInOs(data)
      return true
    } catch (e) {
      return false
    }
  },

  async create ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await create(data)
      return true
    } catch (e) {
      const msg = e.message === 'alreadyExists'
        ? { message: 'Serial com Prefixo e Intervalo informados já cadastrado!' }
        : e

      dispatch('notify/error', msg, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async movementBatch ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await movementBatch(data)
      return true
    } catch (e) {
      const messages = [
        'paymentPending',
        'vehicleNotFound',
        'noSimCardLinkedToTracker',
        'vehicleHasTracker',
        'serialHasMoreThanOneOS',
        'vehicleNotFoundInFinancial'
      ]

      if (messages.includes(e.message)) {
        dispatch('notify/error', e, { root: true })

        return false
      }

      return { error: true, errors: e }
    }
  },

  async activeMovementReport ({ commit }, queriesParams) {
    const actives = await activesMovementReport(queriesParams)
    commit('setActivesMovementReport', actives)
  },

  async activesMovementReportPDF ({ commit }, queriesParams) {
    try {
      const pdfStructure = await fetchActivesMovementReportPDF(queriesParams)

      return pdfStructure
    } catch (e) {
      dispatch('notify/error', e, { root: true })

      return false
    }
  },

  async fetchAllSimcard ({ dispatch, commit }) {
    try {
      const simCards = await fetchAllSimcard()
      commit('setAllSimcards', simCards)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async linkTrackerAndSimcard ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await linkTrackerAndSimcard(data)
      return true
    } catch (e) {
      const msg = e.message === 'alreadyExists'
        ? { message: 'Simcard já está vinculado a outro rastreador!' }
        : e

      dispatch('notify/error', msg, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async loadActivesByService ({ dispatch, commit }, queriesParams) {
    try {
      const actives = await loadActivesByService(queriesParams)
        commit('setAll', actives)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async removeActiveInVehicle ({ dispatch, commit }, { active }) {
    const newActives = []
    for (const item of state.all) {
      if (item.id !== active.id) {
        newActives.push(item)
      }
    }
    commit('setAll', newActives)

    return true
  },

  async addActiveInVehicle ({ dispatch, commit }, { active }) {
    commit('addActiveInList', active)

    return true
  },

  async linkActiveModelAndSimcard ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await linkActiveModelAndSimcard(data)
      return true
    } catch (e) {
      const msg = e.message === 'alreadyExists'
        ? { message: 'Simcard já está vinculado a outro ativo!' }
        : e

      dispatch('notify/error', msg, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async addTrackersBatch ({ dispatch, commit }, data) {
    try {
      dispatch('overlay/show', true, { root: true })
      commit('setLoading', true)
      commit('setAddTrackersBatchErrors', [])

      const { errors } = await addTrackersBatch(data)

      if (errors.length) {
        commit('setAddTrackersBatchErrors', errors)
      }

      return true
    } catch (e) {
      const msg = e.message === 'alreadyExists'
        ? { message: 'Serial com Prefixo e Intervalo informados já cadastrado!' }
        : e

      dispatch('notify/error', msg, { root: true })

      return false
    } finally {
      dispatch('overlay/show', false, { root: true })
      commit('setLoading', false)
    }
  },

  async addSimcardsBatch ({ dispatch, commit }, data) {
    try {
      dispatch('overlay/show', true, { root: true })
      commit('setLoading', true)
      commit('setAddSimcardsBatchErrors', [])

      const { errors } = await addSimcardsBatch(data)

      if (errors.length) {
        commit('setAddSimcardsBatchErrors', errors)
      }

      return true
    } catch (e) {
      const msg = e.message === 'alreadyExists'
        ? { message: 'Serial com Prefixo e Intervalo informados já cadastrado!' }
        : e

      dispatch('notify/error', msg, { root: true })

      return false
    } finally {
      dispatch('overlay/show', false, { root: true })
      commit('setLoading', false)
    }
  },
}

const mutations = {
  cleanState (state) {
    state.all                  = []
    state.isLoading            = false
    state.activeById           = null
    state.activeMovementReport = []
  },

  setAll (state, active) {
    state.all = active
  },

  setAllAvailable (state, availableToChange) {
    state.allAvailableToChange = availableToChange
  },

  addActiveInList (state, active) {
    state.all.push(active)
  },

  setActivesMovementReport(state, activesMovement) {
    state.activesMovementReport = activesMovement
  },

  setActiveById (state, active) {
    state.activeById = active
    // state.activeById = {
    //   id: active.id,
    //   model: active.model,
    //   serie: active.serie,
    //   activeType: active.activeType,
    //   isActive: active.isActive,
    //   location: active.location,
    //   garageAccredited: active.garageAccredited,
    //   purchaseDate: active.purchaseDate,
    //   purchaseValue: active.purchaseValue,
    //   warrantyDate: active.warrantyDate,
    //   registerType: active.registerType,
    //   amountItems: active.amountItems,
    //   prefix: active.prefix,
    //   obs: active.obs,
    //   manufacturer: active.manufacturer,
    //   status: active.status,
    //   fieldExtra1: active.fieldExtra1,
    //   fieldExtra2: active.fieldExtra2,
    //   fieldExtra3: active.fieldExtra3,
    //   linked: active.linked
    // }
  },

  setAllSimcards (state, simCard) {
    state.allSimcard = simCard
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },

  setAddTrackersBatchErrors (state, errors) {
    state.addTrackersBatchErrors = errors
  },

  setAddSimcardsBatchErrors (state, errors) {
    state.addSimcardsBatchErrors = errors
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
